module.exports = __webpack_public_path__ + "static/media/FotosMaca.8e59309d.jpg";